<script setup lang="ts">
interface AppCollapseTransitionProps {
  height: string;
}

defineProps<AppCollapseTransitionProps>();
</script>

<template>
  <transition name="collapse">
    <slot />
  </transition>
</template>

<style scoped lang="scss">
.collapse-leave-active,
.collapse-enter-active,
.collapse-move {
  transition: height var(--transition-long);
}

.collapse-leave-from,
.collapse-enter-to {
  height: v-bind(height);
}

.collapse-leave-to,
.collapse-enter-from {
  height: 0;
}
</style>
